/*
 * @Author: fan.lion@foxmail.com
 * @Date: 2020-02-11 16:47:21
 * @Last Modified by: kq.zheng
 * @Last Modified time: 2020-05-08 14:14:39
 *
 * 周菜谱模块设置
 */

const api = {
	listStoreOpeningCalendars: '/store/listStoreOpeningCalendars', // 查询店铺销售日历列表
	listValidSections: '/section/listValidSections', // 获取分类列表，有效的
	listSectionsHasCommodity: '/section/listSectionsHasCommodity', // 获取分类列表，有效的
	listSections: '/section/listSections', // 获取分类列表
	listCommodities: '/commodity/listCommodities', // 商品列表
	listCommoditiesByOpeningCalendarId: '/commodity/listCommoditiesByOpeningCalendarId', // 获取某个销售日历下所有商品
	saveOrUpdateCookBooks: '/store/saveOrUpdateCookBooks', // 新增和修改店铺某个销售日历下的菜谱

};

const routes = {
	'/cookbook-manage': '周菜谱'
};

export {
	api,
	routes,
};
